<template>
  <v-container class="pa-0">
    <v-form v-model="formValid" ref="form" autocomplete="off" lazy-validation>
      <h1 v-if="!isMobile" class="wizard-header-text"> {{ title }} </h1>
      <v-btn v-if="debug" @click="validate()">Validovat</v-btn>
      <debug-control
        @click="log"
        v-if="debug"
        :value="[
          'validationObjectResult',
          'formValid',
          'somethingIsLoading',
          'somethingGetDirty',
          'currentControl',
        ]"
        :parent="this"
      />
      <v-row class="card" no-gutters>
          <span class="gs100">
              Vyberte si typ produktu a frekvenciu splácania, ktoré vám najviac vyhovujú.
          </span>
        <v-btn-toggle
          class="button-group row no-gutters button-group-select mr-0 ml-0 produkt-group"
          group
          multiple
          v-model="l_value"
          :rules="[validate]"
          @change="
            val => {
              this.setDirty(true);
              update(val);
            }
          "
          :max="4"
          :class="{ readonly: readonly || isDisabled || isLoading }"
        >
          <v-col cols="12" style="padding: 0px !important">
            <v-row
              no-gutters
              class="mt-6 ml-0 mr-0"
              v-for="(item, index) in categories"
              :key="index"
            >
              <v-col cols="12" v-if="index != 0 && index != categories.length " xl="12" lg="12" md="12" class="mb-6">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="12" xl="12" lg="12" md="12">
                <v-row>
                  <v-col cols="12" md="8">
                    <div class="mb-3" style="font-size: 18px; font-weight: 700;">
                      {{ item.key }}
                      <v-icon
                        v-if="isMobile"
                        @click="openMobileProduktInfo(item)"
                        class="btn-help ml-2"
                      >
                        mdi-help-circle
                      </v-icon>
                      
                    </div>
                  </v-col>
                  <v-col cols="12" md="4" v-if="isOLFSInArray(item)" :style="!isMobile ?'text-align:end':'padding-top: 0px !important; padding-bottom: 12px !important'">
                    <v-btn outlined  class="produkt_porovnanie_balikov" @click="openPorovnanieBalikovDialog()"> <v-icon size="17">$produkt_porovnanie_balikov</v-icon> Porovnanie balíkov</v-btn>
                  </v-col>
                </v-row>
                
              </v-col>
              <v-col cols="12" v-if="!isMobile" xl="12" lg="12" md="12">
                <div class="mb-3 gs100" style="font-size: 16px">
                  <span style="white-space: pre-line">{{ item.popis }}</span>
                </div>
              </v-col>
              <v-col
                cols="12"
                xl="4"
                lg="4"
                md="6"
                sm="12"
                class="pl-0 pr-0 button-group-select--btn"
                v-for="(button, index) in item.children"
                :key="index"
              >
                <v-btn
                  :value="button.valueMember"
                  :disabled="isDisabled || (button.is_enabled != null && !button.is_enabled)"
                  outlined
                  style="font-weight:700"
                  :class="[
                    'pa-0',
                    'no-disabled',
                    { 'premium-btn': button.is_enabled != null && !button.is_enabled },
                  ]"
                >
                  {{ button.displayMember }}
                  <v-tooltip v-if="!isMobile && button.popis" left max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        class="btn-help ml-2"
                        style="pointer-events: auto; cursor: default"
                        v-bind="attrs"
                        v-on="on"
                      >
                        mdi-help-circle
                      </v-icon>
                    </template>
                    <span>{{ button.popis }}</span>
                  </v-tooltip>
                </v-btn>
              </v-col>
              <v-col xl="12" lg="12" md="12" v-if="isOLFSInArray(item) && selectedOLFS">
                <v-form v-model="olfsFormValid" ref="olfsForm" autocomplete="off">
                  <v-row>
                    <v-col xl="12" lg="12" md="12"><v-divider></v-divider></v-col>
                  </v-row>
                  <v-row>
                    <v-col xs="12" sm="12" md="12">
                      <v-row>
                        <v-col xl="12" lg="12" md="12">
                          <div class="mb-3" style="font-size: 16px; font-weight: 700;">
                            Doplňte informácie pre Operatívny leasing
                          </div>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col 
                          cols="12"
                          md="3"
                          sm="12">
                          <v-row no-gutters>
                            <span class="f12 gs100">Značka a model</span>
                          </v-row>
                          <v-row no-gutters class="bold">
                            <span class="f16">
                              {{ znackaDisplay }} {{ modelDisplay }}
                            </span>
                          </v-row>
                          <v-row no-gutters v-if="isMobile">
                            <span class="f12 gs100">
                              {{ getRefTooltip($refs.modely_verzie)}}
                            </span>
                          </v-row>
                          <dynamic-combo
                            v-show="false"
                            ref="znacka"
                            key="liw_filip__wiz_predmet__cb_znacky"
                            data-id="liw_filip__wiz_predmet__cb_znacky"
                            :cisloPredmetu="pripad.cisloPredmetu"
                            @input="onZnackaChanged"
                          ></dynamic-combo>
                          <dynamic-combo
                            v-show="false"
                            ref="modely"
                            key="liw_filip__wiz_predmet__cb_modely"
                            data-id="liw_filip__wiz_predmet__cb_modely"
                            :cisloPredmetu="pripad.cisloPredmetu"
                            @input="onModelChanged"
                          ></dynamic-combo>
                          <numeric-text-box
                            ref="poplatok_di_zakl"
                            key="liw_filip__wiz_produkt__txt_poplatok_di_zakl"
                            data-id="liw_filip__wiz_produkt__txt_poplatok_di_zakl"
                            :cisloPredmetu="pripad.cisloPredmetu"
                            hideLabel
                            hide-details
                            hide-tooltip
                          />
                          <numeric-text-box
                            ref="poplatok_di_dph"
                            key="liw_filip__wiz_produkt__txt_poplatok_di_s_dph"
                            data-id="liw_filip__wiz_produkt__txt_poplatok_di_s_dph"
                            :cisloPredmetu="pripad.cisloPredmetu"
                            hideLabel
                            hide-details
                            hide-tooltip
                          />
                        </v-col>
                        <v-col cols="12" sm="12" md="6" style="padding: 12px 5px">
                          <dynamic-combo
                            ref="modely_verzie"
                            @valueChanged="onModelyVerzieValueChanged"
                            clearable
                            key="liw_filip__wiz_predmet__cb_modely_verzie"
                            data-id="liw_filip__wiz_predmet__cb_modely_verzie"
                            :cisloPredmetu="pripad.cisloPredmetu"
                            fulltext-filter
                            hide-tooltip
                          ></dynamic-combo>
                        </v-col>
                        <v-col style="align-self: center; margin-top:-12px; padding-left:0px" v-if="!isMobile">
                          <v-tooltip v-if="!!getRefTooltip($refs.modely_verzie) " bottom max-width="350">
                            <template v-slot:activator="{ on }">
                              <v-icon slot="activator" class="btn-help text-body-2" v-on="on"
                                >mdi-help-circle</v-icon
                              >
                            </template>
                            <span> {{ getRefTooltip($refs.modely_verzie)}} </span>
                          </v-tooltip>
                        </v-col>
                      </v-row>
                      <v-row :class="!isMobile ? 'mx-0' :''">
                        <v-col cols="12">
                          <v-row v-if="!isMobile">
                            <v-col cols="12" md="3"></v-col>
                            <v-col cols="12" md="3" class="f16 bold">Cena bez DPH</v-col>
                            <v-col cols="12" md="4" class="f16 ">
                              <span class="bold">
                                Cena vratane DPH
                              </span>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" md="3" style="align-self: center;">
                              <span class="gs100 text-required">
                                {{ getRefLabel($refs.cennikova_cena_zakl)  }}
                              </span>
                                <v-tooltip v-if="!!getRefTooltip($refs.cennikova_cena_zakl) && !isMobile" bottom max-width="350">
                                  <template v-slot:activator="{ on }">
                                    <v-icon slot="activator" class="btn-help text-body-2" v-on="on"
                                      >mdi-help-circle</v-icon
                                    >
                                  </template>
                                  <span> {{ getRefTooltip($refs.cennikova_cena_zakl)}} </span>
                                </v-tooltip>
                            </v-col>
                            <v-col cols="12" no-gutters v-if="!!getRefTooltip($refs.cennikova_cena_zakl) && isMobile" style="padding-top: 0px;">
                              <span class="f12 gs100">
                                {{ getRefTooltip($refs.cennikova_cena_zakl)}}
                              </span>
                            </v-col>
                            <v-col cols="6" md="3">
                              <numeric-text-box
                                ref="cennikova_cena_zakl"
                                key="liw_filip__wiz_produkt__txt_cena_noveho_vozidla_zakl"
                                data-id="liw_filip__wiz_produkt__txt_cena_noveho_vozidla_zakl"
                                :cisloPredmetu="pripad.cisloPredmetu"
                                suffix="€"
                                :decimalPlaces="2"
                                :textRight="false"
                                :hideLabel="!isMobile"
                                :customLabel="isMobile ? 'Cena bez DPH' : null"
                                :rules="[cenaRule]" 
                                placeholder="0,00"
                                hide-tooltip     
                                replaceNull                      
                                @valueChanged="()=> onCennikovaCenaZaklChanged()"
                              />
                            </v-col>
                            <v-col cols="6" md="3" >
                              <numeric-text-box
                                ref="cennikova_cena_s_dph"
                                key="liw_filip__wiz_produkt__txt_cena_noveho_vozidla_s_dph"
                                data-id="liw_filip__wiz_produkt__txt_cena_noveho_vozidla_s_dph"
                                :cisloPredmetu="pripad.cisloPredmetu"
                                suffix="€"
                                :decimalPlaces="2"
                                :textRight="false"
                                :hideLabel="!isMobile"
                                :customLabel="isMobile ? 'Cena vratane DPH' : null"
                                :rules="[cenaRule]"
                                placeholder="0,00"
                                hide-tooltip      
                                replaceNull                     
                                @valueChanged="()=> onCennikovaCenaSDPHChanged()"
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col xl="12" lg="12" md="12"><v-divider></v-divider></v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" md="3" style="align-self: center;">
                              <span class="gs100">
                                {{ getRefLabel($refs.cena_prislusenstva_zakl) }}
                              </span>
                              <v-tooltip v-if="!!getRefTooltip($refs.cena_prislusenstva_zakl) && !isMobile " bottom max-width="350">
                                <template v-slot:activator="{ on }">
                                  <v-icon slot="activator" class="btn-help text-body-2" v-on="on"
                                    >mdi-help-circle</v-icon
                                  >
                                </template>
                                <span> {{ getRefTooltip($refs.cena_prislusenstva_zakl) }} </span>
                              </v-tooltip>
                            </v-col>
                            <v-col cols="12" no-gutters v-if="!!getRefTooltip($refs.cena_prislusenstva_zakl) && isMobile" style="padding-top: 0px;">
                              <span class="f12 gs100">
                                {{ getRefTooltip($refs.cena_prislusenstva_zakl)}}
                              </span>
                            </v-col>
                            <v-col cols="6" md="3">
                              <numeric-text-box
                                ref="cena_prislusenstva_zakl"
                                key="liw_filip__wiz_produkt__txt_cena_prislusenstva_zakl"
                                data-id="liw_filip__wiz_produkt__txt_cena_prislusenstva_zakl"
                                :cisloPredmetu="pripad.cisloPredmetu"
                                suffix="€"
                                :decimalPlaces="2"
                                :textRight="false"
                                :hideLabel="!isMobile"
                                :customLabel="isMobile ? 'Cena bez DPH' : null"
                                placeholder="0,00"
                                hide-details
                                hide-tooltip
                                replaceNull
                                @valueChanged="()=> onCenaPrislusenstvaZaklChanged()"
                              />
                            </v-col>
                            <v-col cols="6" md="3">
                              <numeric-text-box
                                ref="cena_prislusenstva_s_dph"
                                key="liw_filip__wiz_produkt__txt_cena_prislusenstva_s_dph"
                                data-id="liw_filip__wiz_produkt__txt_cena_prislusenstva_s_dph"
                                :cisloPredmetu="pripad.cisloPredmetu"
                                suffix="€"
                                :decimalPlaces="2"
                                :textRight="false"
                                :hideLabel="!isMobile"
                                :customLabel="isMobile ? 'Cena vratane DPH' : null"
                                placeholder="0,00"
                                hide-details
                                hide-tooltip
                                replaceNull
                                @valueChanged="()=> onCenaPrislusenstvaSDPHChanged()"
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col xl="12" lg="12" md="12"><v-divider></v-divider></v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" md="3" style="align-self: center;">
                              <span class="gs100">
                                {{ getRefLabel($refs.zlava_zakl)}}
                              </span>
                              <v-tooltip v-if="!!getRefTooltip($refs.zlava_zakl) && !isMobile" bottom max-width="350">
                                <template v-slot:activator="{ on }">
                                  <v-icon slot="activator" class="btn-help text-body-2" v-on="on"
                                    >mdi-help-circle</v-icon
                                  >
                                </template>
                                <span> {{ getRefTooltip($refs.zlava_zakl) }} </span>
                              </v-tooltip>
                            </v-col>
                            <v-col cols="12" no-gutters v-if="!!getRefTooltip($refs.zlava_zakl) && isMobile" style="padding-top: 0px;">
                              <span class="f12 gs100">
                                {{ getRefTooltip($refs.zlava_zakl)}}
                              </span>
                            </v-col>
                            <v-col cols="6" md="3">
                              <numeric-text-box
                                ref="zlava_zakl"
                                key="liw_filip__wiz_produkt__txt_zlava_zakl"
                                data-id="liw_filip__wiz_produkt__txt_zlava_zakl"
                                :cisloPredmetu="pripad.cisloPredmetu"
                                suffix="€"
                                :decimalPlaces="2"
                                :textRight="false"
                                :hideLabel="!isMobile"
                                :customLabel="isMobile ? 'Cena bez DPH' : null"
                                placeholder="0,00"
                                hide-details
                                hide-tooltip
                                replaceNull
                                @valueChanged="()=> onZlavaZalkChanged()"
                              />
                            </v-col>
                            <v-col cols="6" md="3">
                              <numeric-text-box
                                ref="zlava_s_dph"
                                key="liw_filip__wiz_produkt__txt_zlava_s_dph"
                                data-id="liw_filip__wiz_produkt__txt_zlava_s_dph"
                                :cisloPredmetu="pripad.cisloPredmetu"
                                suffix="€"
                                :decimalPlaces="2"
                                :textRight="false"
                                :hideLabel="!isMobile"
                                :customLabel="isMobile ? 'Cena vratane DPH' : null"
                                placeholder="0,00"
                                hide-details
                                hide-tooltip
                                replaceNull
                                @valueChanged="()=> onZlavaSDPHChanged()"
                              />
                            </v-col>
                            <v-col cols="6" md="3">
                              <numeric-text-box
                                ref="zlava_perc"
                                key="liw_filip__wiz_produkt__txt_zlava_perc"
                                data-id="liw_filip__wiz_produkt__txt_zlava_perc"
                                :cisloPredmetu="pripad.cisloPredmetu"
                                suffix="%"
                                :decimalPlaces="2"
                                :textRight="false"
                                :hideLabel="!isMobile"
                                :customLabel="isMobile ? 'Zľava' : null"
                                placeholder="0,00"
                                hide-details
                                hide-tooltip
                                replaceNull
                                @valueChanged="()=> onZlavaPercChanged()"
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col xl="12" lg="12" md="12"><v-divider></v-divider></v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" md="3" style="align-self: center;">
                              <span class="gs100">
                                {{ getRefLabel($refs.dodat_vybava_zakl) }}
                              </span>
                              <v-tooltip v-if="!!getRefTooltip($refs.dodat_vybava_zakl) && !isMobile" bottom max-width="350">
                                <template v-slot:activator="{ on }">
                                  <v-icon slot="activator" class="btn-help text-body-2" v-on="on"
                                    >mdi-help-circle</v-icon
                                  >
                                </template>
                                <span> {{ getRefTooltip($refs.dodat_vybava_zakl) }} </span>
                              </v-tooltip>
                            </v-col>
                            <v-col cols="12" no-gutters v-if="!!getRefTooltip($refs.dodat_vybava_zakl) && isMobile" style="padding-top: 0px;">
                              <span class="f12 gs100">
                                {{ getRefTooltip($refs.dodat_vybava_zakl)}}
                              </span>
                            </v-col>
                            <v-col cols="6" md="3">
                              <numeric-text-box
                                ref="dodat_vybava_zakl"
                                key="liw_filip__wiz_produkt__txt_dod_vybava_zakl"
                                data-id="liw_filip__wiz_produkt__txt_dod_vybava_zakl"
                                :cisloPredmetu="pripad.cisloPredmetu"
                                suffix="€"
                                :decimalPlaces="2"
                                :textRight="false"
                                :hideLabel="!isMobile"
                                :customLabel="isMobile ? 'Cena bez DPH' : null"
                                placeholder="0,00"
                                hide-details
                                hide-tooltip
                                replaceNull
                                @valueChanged="()=> onDodatVybavaZaklChanged()"
                              />
                            </v-col>
                            <v-col cols="6" md="3">
                              <numeric-text-box
                                ref="dodat_vybava_s_dph"
                                key="liw_filip__wiz_produkt__txt_dod_vybava_s_dph"
                                data-id="liw_filip__wiz_produkt__txt_dod_vybava_s_dph"
                                :cisloPredmetu="pripad.cisloPredmetu"
                                suffix="€"
                                :decimalPlaces="2"
                                :textRight="false"
                                :hideLabel="!isMobile"
                                :customLabel="isMobile ? 'Cena vratane DPH' : null"
                                placeholder="0,00"
                                hide-details
                                hide-tooltip
                                replaceNull
                                @valueChanged="()=> onDodatVybavaSDPHChanged()"
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col xl="12" lg="12" md="12"><v-divider></v-divider></v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" md="3" style="align-self: center;">
                              <span class="gs100">
                                {{ getRefLabel($refs.fakturovana_cena_zakl)}}
                              </span>
                              <v-tooltip v-if="!!getRefTooltip($refs.fakturovana_cena_zakl) && !isMobile" bottom max-width="350">
                                <template v-slot:activator="{ on }">
                                  <v-icon slot="activator" class="btn-help text-body-2 ml-2" v-on="on"
                                    >mdi-help-circle</v-icon
                                  >
                                </template>
                                <span> {{ getRefTooltip($refs.fakturovana_cena_zakl) }} </span>
                              </v-tooltip>
                            </v-col>
                            <v-col cols="12" no-gutters v-if="!!getRefTooltip($refs.fakturovana_cena_zakl) && isMobile" style="padding-top: 0px;">
                              <span class="f12 gs100">
                                {{ getRefTooltip($refs.fakturovana_cena_zakl)}}
                              </span>
                            </v-col>
                            <v-col cols="6" md="3">
                              <numeric-text-box
                                ref="fakturovana_cena_zakl"
                                key="liw_filip__wiz_produkt__txt_fakturovana_cena_zakl"
                                data-id="liw_filip__wiz_produkt__txt_fakturovana_cena_zakl"
                                :cisloPredmetu="pripad.cisloPredmetu"
                                suffix="€"
                                :decimalPlaces="2"
                                :textRight="false"
                                :hideLabel="!isMobile"
                                :customLabel="isMobile ? 'Cena bez DPH' : null"
                                placeholder="0,00"
                                hide-details
                                hide-tooltip
                                replaceNull
                              />
                            </v-col>
                            <v-col cols="6" md="3">
                              <numeric-text-box
                                ref="fakturovana_cena_s_dph"
                                key="liw_filip__wiz_produkt__txt_fakturovana_cena_s_dph"
                                data-id="liw_filip__wiz_produkt__txt_fakturovana_cena_s_dph"
                                :cisloPredmetu="pripad.cisloPredmetu"
                                suffix="€"
                                :decimalPlaces="2"
                                :textRight="false"
                                :hideLabel="!isMobile"
                                :customLabel="isMobile ? 'Cena vratane DPH' : null"
                                placeholder="0,00"
                                hide-details
                                hide-tooltip
                                replaceNull
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col xl="12" lg="12" md="12"><v-divider></v-divider></v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" md="3" style="align-self: center;">
                              <span class="gs100">
                                {{ getRefLabel($refs.kupna_cena_zakl)}}
                              </span>
                              <v-tooltip v-if="!!getRefTooltip($refs.kupna_cena_zakl) && !isMobile" bottom max-width="350">
                                <template v-slot:activator="{ on }">
                                  <v-icon slot="activator" class="btn-help text-body-2 ml-2" v-on="on"
                                    >mdi-help-circle</v-icon
                                  >
                                </template>
                                <span> {{ getRefTooltip($refs.kupna_cena_zakl) }} </span>
                              </v-tooltip>
                            </v-col>
                            <v-col cols="12" no-gutters v-if="!!getRefTooltip($refs.kupna_cena_zakl) && isMobile" style="padding-top: 0px;">
                              <span class="f12 gs100">
                                {{ getRefTooltip($refs.kupna_cena_zakl)}}
                              </span>
                            </v-col>
                            <v-col cols="6" md="3">
                              <numeric-text-box
                                ref="kupna_cena_zakl"
                                key="liw_filip__wiz_produkt__txt_kupna_cena_zakl"
                                data-id="liw_filip__wiz_produkt__txt_kupna_cena_zakl"
                                :cisloPredmetu="pripad.cisloPredmetu"
                                suffix="€"
                                :decimalPlaces="2"
                                :textRight="false"
                                :hideLabel="!isMobile"
                                :customLabel="isMobile ? 'Cena bez DPH' : null"
                                placeholder="0,00"
                                hide-details
                                hide-tooltip
                                replaceNull
                              />
                            </v-col>
                            <v-col cols="6" md="3">
                              <numeric-text-box
                                ref="kupna_cena_s_dph"
                                key="liw_filip__wiz_produkt__txt_kupna_cena_s_dph"
                                data-id="liw_filip__wiz_produkt__txt_kupna_cena_s_dph"
                                :cisloPredmetu="pripad.cisloPredmetu"
                                suffix="€"
                                :decimalPlaces="2"
                                :textRight="false"
                                :hideLabel="!isMobile"
                                :customLabel="isMobile ? 'Cena vratane DPH' : null"
                                placeholder="0,00"
                                hide-details
                                hide-tooltip
                                replaceNull
                              />
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row> 
                </v-form>
              </v-col>
              <v-col xl="12" lg="12" md="12" v-if="item.info">
                <div class="mt-3 toggle-info-text" style="font-size: 16px">
                  <span style="white-space: pre-line">{{ item.info }}</span>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-btn-toggle>
      </v-row>
    </v-form>
    <v-dialog v-model="porovnanieBalikovDialog" max-width="896">
      <v-card class="dialog-card">
        <v-card-title class="d-flex justify-space-between dialog-title-close">
          <span> Porovnanie balíkov </span>
          <v-btn icon @click="closePorovnanieBalikov()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="gs100">
          <v-row no-gutters class="mx-0">
            <v-col cols="12">
              <v-row class="mx-0">
                <v-col v-for="(item,index) in porovnanieBalikov" :key="index" cols="12" :md="4">
                  <v-row no-gutters style="gap:8px">
                    <v-col cols="12" class="bold">
                      <span class="f18 white100">
                        {{ item[0].display_member }}
                      </span>
                    </v-col>
                    <v-col cols="12" v-for="(row,rowIndex) in item" :key="rowIndex">
                      <v-icon class="btn-help porovnanie-balikov-icon"
                        size="16px">
                        $check_circle
                      </v-icon>
                      <span>
                        {{ row.sluzba }}
                      </span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import ButtonGroup from '../basic/ButtonGroup.vue';
import TextGroup from '../basic/TextGroup.vue';
import { dynamicControlMixin } from '../../mixins/dynamicControlMixin';
import Utils from '../../plugins/utils';
import { wizardMixin } from '../../mixins/wizardMixin.js';
import { mapState, mapGetters, mapMutations } from 'vuex';
import DynamicCombo from '../basic/DynamicCombo.vue';
import NumericTextBox from '../basic/NumericTextBox.vue';
import protectedAxios from '../../auth/axios';

export default {
  mixins: [dynamicControlMixin, wizardMixin],
  components: { ButtonGroup, TextGroup, DynamicCombo, NumericTextBox },
  props: {},
  data() {
    return {
      defaultMessage: {
            text: 'Pre pokračovanie je potrebné vybrať <b> minimálne 1 </b> možnosť, zároveň <b>maximálne 4 </b>.',
        isError: false,
      },
      categories: [],
      l_value: [],
      olfsValues: [],
      znackaDisplay: '',
      modelDisplay: '',
      porovnanieBalikov:{},
      porovnanieBalikovDialog:false,
      olfsFormValid: false,
      loadingOlfs: false,
    };
  },
  watch:{
    async selectedOLFS(val){
      console.log("selectedOLFS",val);
      if(val){
        this.loadingOlfs = true;
        this.$nextTick(async () => {
          await Promise.all([
            this.loadRefData(this.$refs.znacka),
            this.loadRefData(this.$refs.modely),
            this.loadRefData(this.$refs.modely_verzie),
            this.loadRefData(this.$refs.poplatok_di_zakl),
            this.loadRefData(this.$refs.poplatok_di_dph),
          ]);
          await this.reloadCennikovaCena();
          await this.reloadCenaPrislusenstva();
          await this.reloadZlava();
          await this.reloadDodatVybava();
          await this.reloadFakturovanaAKupnaCena();
          this.refreshZnackaModel();
          this.loadingOlfs = false;
        });
      } else {
        this.znackaDisplay = '';
        this.modelDisplay = '';
      }
    }
  },
  computed: {
    ...mapState(['predmet','pripad']),
    ...mapGetters(['isMobile']),
    selectedOLFS(){
      return this.l_value.some(val => this.olfsValues.includes(val));
    },
  },
  methods: {
    ...mapMutations(['openDialog','closeDialog']),
    refreshZnackaModel() {
      this.znackaDisplay = this.getComboDisplay(this.$refs.znacka);
      this.modelDisplay = this.getComboDisplay(this.$refs.modely);
    },
    getComboDisplay(comboRef) {
      if (!comboRef) return '';
      const _comboRef = Array.isArray(comboRef)
        ? comboRef[0]
        : comboRef;
      return (
        _comboRef.data.find(
          i => i.valueMember == _comboRef.currentValue
        )?.displayMember ?? ''
      );
    },
    onZnackaChanged() {
      this.znackaDisplay = this.getComboDisplay(this.$refs.znacka);
    },
    onModelChanged() {
      this.modelDisplay = this.getComboDisplay(this.$refs.modely);
    },
    async readData(config, data) {
      this.initComplete = true;
      this.categories = Utils.groupBy(data, datum => datum.category);
      this.categories = this.categories.map(c => {
        return {
          key: c.key,
          children: c.children,
          popis: c.children[0].popis_leasingu,
          info: this.getPopisPredvoleny(c.children),
        };
      });
      this.olfsValues = data.filter(d => d.je_olfs === 1).map(d => d.valueMember);
      this.l_value = [];
      if (config.controlValue !== null && config.controlValue !== undefined) {
        let contValues = config.controlValue.split(',').map(x => +x);
        contValues.forEach(element => {
          if (data.find(d => d.valueMember === element)) {
            this.l_value.push(element);
          }
        });
        const olfsFlOrSu = await protectedAxios
            .get(
              `/pripady/${this.pripad.newId}/je-olfs/${
                this.pripad.cisloPredmetu
              }`
            )
            .then(res => res.data);
        this.pripad.jeFlSu = olfsFlOrSu.je_fl_su;
        this.pripad.jeOlfs = olfsFlOrSu.je_olfs;
      }
      this.validate();
    },
    update(val) {
      if (!this.isLoading) {
        //this.setValid(true, 'pripadyWizardProdukt', '', false);
        this.$emit('input', val);
        this.saveValue(val);
        this.validate();
      }
    },
    reload() {
      this.loadData();
    },
    //beforeStep vola PripadyWizard.vue po validacii formulara. Musi vratit promise !!!
    async beforeStep() {
      try{
        this.clearDirty();
        if(await this.validate()){
          const olfsFlOrSu = await protectedAxios
            .get(
              `/pripady/${this.pripad.newId}/je-olfs/${
                this.pripad.cisloPredmetu
              }`
            )
            .then(res => res.data);
          this.pripad.jeFlSu = olfsFlOrSu.je_fl_su;
          this.pripad.jeOlfs = olfsFlOrSu.je_olfs;
          if(this.pripad.jeOlfs){
            let _refMV = Array.isArray(this.$refs.modely_verzie) ? this.$refs.modely_verzie[0] : this.$refs.modely_verzie;
            if(!_refMV.currentValue) return Promise.resolve(false);
            if(_refMV){
              const checkOlfsIdVerzie = await protectedAxios
              .get(
                `/pripady/${this.pripad.newId}/check-ofls-model-verzie/${_refMV.currentValue}`
              )
              .then(res => res.data); 
              if(!checkOlfsIdVerzie){
                let _dialog = {
                  persistent: true,
                  header: `<span class="gs100 f16">Kontaktujte nás</span>`,
                  closeIcon: {
                    value: true,
                    func: null
                  },
                  text: `<span class="f16">Nie je možné kalkulovať <span class="bold""> Operatívny leasing pre Vami zadaný predmet</span> pomocou Leasingového asistenta<sup>TL</sup>. Kontaktujte nás pre osobitnú kalkuláciu.</span>` + "<br>" + "<a>Pomôžeme vám?</a></a>",
                  primaryBtn: {
                    text: `Pokračovať`,
                    func: null,
                  },
                };

                _dialog.primaryBtn.func = () => {
                  this.closeDialog();
                };
                _dialog.closeIcon.func = () => {
                  this.closeDialog();
                };

                
                this.openDialog(_dialog);
                return Promise.resolve(false);
              }
            }else{
              return Promise.resolve(false);
            } 
          }
          return Promise.resolve(true);
        }else{
          return Promise.resolve(false);
        }
      }catch(e){
        console.error(e)
        return Promise.resolve(false);
      }
      
    },
      getInfoText(key) {
          switch (key) {
              case 'FL':
                  return 'Ideálne riešenie, ako formou <span class="bold">dlhodobého prenájmu</span> financovať automobily, stroje a zariadenia, či nehnuteľnosti. Mesačná leasingová splátka už obsahuje nájomné aj úroky. Po skončení finančného leasingu môžete predmet odkúpiť alebo nám ho vrátiť. ';
              case 'SU':
                  return 'Získate <span class="bold">finančné prostriedky na kúpu</span> tovaru alebo služby. Náš spotrebný úver sme navrhli špeciálne pre potreby firiem. Majiteľom predmetu sa stanete ihneď po splatení úveru.';
              default:
                  return '';
          }
      },
    async validate() {
      this.setValid(true, 'pripadyWizardProdukt', this.defaultMessage.text, false);
      if (this.l_value.length > 0 && this.l_value.length <= 4) {
        if(this.selectedOLFS && this.getRef(this.$refs.olfsForm)){   
          if(this.loadingOlfs) {
            await this.waitLoadingOlfsFalse();
          }   
          if(!this.getRef(this.$refs.olfsForm).validate()){
            this.setValid(false, 'pripadyWizardProdukt', "Vyplnte prosím povinné polia!", false);
            return false;
          }
        }
        this.setValid(true, 'pripadyWizardProdukt', this.defaultMessage.text, false);
        return true;
      } else {
        this.setValid(false, 'pripadyWizardProdukt', this.defaultMessage.text, false);
        return false;
      }
    },
    getPopisPredvoleny(items) {
      for (let i = 0; i < items.length; i++) {
        if (items[i].popis_predvoleny) {
          return items[i].popis_predvoleny;
        }
      }
      return null;
    },
    openMobileProduktInfo(item) {
      let text = '';
      item.children.forEach(element => {
        text += `<span class="f16 white100" style="font-weight:700">${element.displayMember}</span><br>`
        text += `<span class="f16" style="color:#9194a4">${element.popis}</span><br><br>`
      })
      let popisText = '';
      if (item.popis != '')
      {
        popisText = `<span class="f16" style="color:#9194a4">${item.popis}</span><br><br>`
      }
      let dialog = {
          header: `<span class="f16 white60">${item.key}</span>`,
          text: `${popisText}<span class="f16">${text}</span>`,
          closeIcon: {
            value: true,
          },
        };
        this.openDialog(dialog);
    },
    isOLFSInArray(item){
      if(item.key == 'Operatívny leasing'){
        return item.children.some((child)=> child.je_olfs == 1)
      }
      return false;
    },
    loadRefData(ref){
      if(!ref) return;
      let _ref = Array.isArray(ref) ? ref[0] : ref;
      if(_ref)
        return _ref.loadData();
      return;
    },
    async reloadCennikovaCena(){
      await this.loadRefData(this.$refs.cennikova_cena_s_dph);
      await this.loadRefData(this.$refs.cennikova_cena_zakl);
      return;
    },
    async reloadCenaPrislusenstva(){
      await this.loadRefData(this.$refs.cena_prislusenstva_s_dph)
      await this.loadRefData(this.$refs.cena_prislusenstva_zakl);
      return;
    },
    async reloadZlava(){
      return await Promise.all([
        this.loadRefData(this.$refs.zlava_zakl),
        this.loadRefData(this.$refs.zlava_s_dph),
        this.loadRefData(this.$refs.zlava_perc)
      ]);
      
    },
    async reloadDodatVybava(){
      return await Promise.all([
        this.loadRefData(this.$refs.dodat_vybava_zakl),
        this.loadRefData(this.$refs.dodat_vybava_s_dph)
      ]);
    },    
    async reloadFakturovanaAKupnaCena(){
      return await Promise.all([
        this.loadRefData(this.$refs.fakturovana_cena_zakl),
        this.loadRefData(this.$refs.fakturovana_cena_s_dph),
        this.loadRefData(this.$refs.kupna_cena_zakl),
        this.loadRefData(this.$refs.kupna_cena_s_dph)
      ]);
    },
    async onModelyVerzieValueChanged() {
      await this.$emit('modelyVerzieChanged', this.pripad?.cisloPredmetu);
      await this.loadRefData(this.$refs.poplatok_di_zakl);
      await this.loadRefData(this.$refs.poplatok_di_dph);
      await this.reloadCennikovaCena();
      await this.reloadCenaPrislusenstva();
      await this.reloadZlava();
      await this.reloadDodatVybava();
      await this.reloadFakturovanaAKupnaCena();
      this.setValid(true, 'pripadyWizardProdukt', "Vyplnte prosím povinné polia!", false);
    },
    async onCennikovaCenaZaklChanged() {
      await this.loadRefData(this.$refs.cennikova_cena_s_dph);
      await this.reloadZlava();
      await this.reloadFakturovanaAKupnaCena();
      this.setValid(true, 'pripadyWizardProdukt', "Vyplnte prosím povinné polia!", false);
    },
    async onCennikovaCenaSDPHChanged() {
      await this.loadRefData(this.$refs.cennikova_cena_zakl);
      await this.reloadZlava();
      await this.reloadFakturovanaAKupnaCena();
      this.setValid(true, 'pripadyWizardProdukt', "Vyplnte prosím povinné polia!", false);
    },
    async onCenaPrislusenstvaZaklChanged() {
      await this.loadRefData(this.$refs.cena_prislusenstva_s_dph);
      await this.reloadFakturovanaAKupnaCena();
    },
    async onCenaPrislusenstvaSDPHChanged() {
      await this.loadRefData(this.$refs.cena_prislusenstva_zakl);
      await this.reloadFakturovanaAKupnaCena();
    },
    async onZlavaZalkChanged() {
      await this.loadRefData(this.$refs.zlava_s_dph);
      await this.loadRefData(this.$refs.zlava_perc);
      await this.reloadFakturovanaAKupnaCena();
    },
    async onZlavaSDPHChanged() {
      await this.loadRefData(this.$refs.zlava_zakl);
      await this.loadRefData(this.$refs.zlava_perc);
      await this.reloadFakturovanaAKupnaCena();
    },
    async onZlavaPercChanged() {
      await this.loadRefData(this.$refs.zlava_zakl);
      await this.loadRefData(this.$refs.zlava_s_dph);
      await this.reloadFakturovanaAKupnaCena();
    },
    async onDodatVybavaZaklChanged() {
      await this.loadRefData(this.$refs.dodat_vybava_s_dph);
      await this.reloadFakturovanaAKupnaCena();
    },
    async onDodatVybavaSDPHChanged() {
      await this.loadRefData(this.$refs.dodat_vybava_zakl);
      await this.reloadFakturovanaAKupnaCena();
    },
    async openPorovnanieBalikovDialog(){
      await protectedAxios
        .get(`/pripady/${this.pripad.newId}/olfs-porovnanie-balikov/${this.pripad.cisloPredmetu}/0`)
        .then(res =>{
          if(res != null){
            this.porovnanieBalikov = res.data.reduce((obj, item) => {
              (obj[item.value_member] ||= []).push(item);
              return obj;
            }, {});
            this.porovnanieBalikovDialog = true;
          }
        });
    },
    closePorovnanieBalikov(){
      this.porovnanieBalikovDialog = false;
      this.porovnanieBalikov = {};
    },
    getRefLabel(ref){
      if(!ref) return "";
      let _ref = Array.isArray(ref) ? ref[0] : ref;
      if(_ref)
        return _ref.l_label;
      return ''
    },
    getRefTooltip(ref){
      if(!ref) return "";
      let _ref = Array.isArray(ref) ? ref[0] : ref;
      if(_ref)
      return _ref.l_tooltip;
    },
    getRef(ref){
      if(!ref) return null;
      return Array.isArray(ref) ? ref[0] : ref;
    },
    cenaRule(v) {
      const num = parseFloat(String(v).replace(/,/g, '.'));
      if (!num && num !== 0) return true;
      if (num <= 0) return 'Hodnota musí byť väčšia ako 0!';
      return true;
    },
    waitLoadingOlfsFalse(){
      return new Promise((resolve)=>{
        let unwatch = this.$watch('loadingOlfs',(val) =>{
          if(val === false){
            unwatch();
            resolve(val);
          }
        },
        {immediate: true})
      })
    }
  },
  created() {
    //this.controlName = 'PripadyWizardProdukt';

    this.l_autoload = false;
    this.l_label = 'produkt';
    this.l_value = [];
    this.l_dataId = 'liw_filip__wiz_produkt__btn_typ_produktu';
    this.l_cisloPredmetu = this.pripad.cisloPredmetu;
  },
  mounted(){
    this.$refs.form.validate = this.validate;
  }
};
</script>
